<template>
  <div class="modal-fade">
    <div class="gray-container create-modal">
      <button
        class="icon-close close-the-modal"
        @click.prevent="$emit('close')"
      ></button>
      <h2>My settings</h2>
      <router-link
        v-if="$p(permissions.user.accessGeneralSettings)"
        @click.native="$emit('close')"
        :to="appRoutes.settingsGeneral"
        class="create-link"
        >General</router-link
      >
      <router-link
        v-if="user.isExpert || user.isProvider"
        @click.native="$emit('close')"
        :to="appRoutes.settingsPermissions"
        class="create-link"
        >Permissions</router-link
      >
      <router-link
        v-if="user.isProvider"
        @click.native="$emit('close')"
        :to="appRoutes.accountList"
        class="create-link"
      >
        Accounts
      </router-link>
      <router-link
        v-if="user.isProvider || user.isUser"
        @click.native="$emit('close')"
        :to="
          appRoutes.settingsConnectionsTab(
            settingsConnectionsTabs.services.value
          )
        "
        class="create-link"
        >Connections</router-link
      >
      <router-link
        v-if="user.isExpert && !user.isProvider"
        @click.native="$emit('close')"
        :to="appRoutes.settingsExpertConnections"
        class="create-link"
        >Connections</router-link
      >
      <router-link
        v-if="user.isProvider || user.isProviderAdmin"
        @click.native="$emit('close')"
        :to="appRoutes.qrCodeSettings(qrCodeSettingsTabs.registration.value)"
        class="create-link"
      >
        QR codes
      </router-link>
    </div>
  </div>
</template>

<script>
import { appRoutes } from "Public/consts/appRoutes";
import userMixin from "Shared/mixins/userMixin";
import {
  SETTINGS_EXPERT_CONNECTIONS_ROUTE,
  SETTINGS_CONNECTIONS_ROUTE,
} from "Consts/publicRoutes";
import { qrCodeSettingsTabs } from "Modules/qrCodes/constants/qrCodeSettingsTabs";
import { settingsConnectionsTabs } from "Views/Settings/Connections/constants/settingsConnectionsTabs";
import { permissions } from "Consts/permissions";

export default {
  name: "SettingsModal",
  computed: {
    permissions() {
      return permissions;
    },
    settingsConnectionsTabs() {
      return settingsConnectionsTabs;
    },
    qrCodeSettingsTabs() {
      return qrCodeSettingsTabs;
    },
  },
  mixins: [userMixin],
  data() {
    return {
      appRoutes,
      SETTINGS_EXPERT_CONNECTIONS_ROUTE,
      SETTINGS_CONNECTIONS_ROUTE,
    };
  },
};
</script>

<style scoped></style>
